/* Customer Photo Reviews — carousel + lightbox (no dependencies) */
(function () {
  if (customElements.get('photo-reviews-carousel')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class PhotoReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.bar = this.querySelector('[data-progress]');
      this.dialog = this.querySelector('[data-lightbox]');
      this.stage = this.querySelector('[data-lb-stage]');
      this.pos = this.querySelector('[data-lb-pos]');
      this.current = 0;
      this.paused = false;
      this.visible = false;
      this.hovered = false;

      this.onScroll = this.onScroll.bind(this);
      this.tick = this.tick.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1, true));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1, true));

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1, true); }
      });

      this.track.addEventListener('click', (e) => {
        var btn = e.target.closest('[data-open]');
        if (btn) this.openLightbox(parseInt(btn.getAttribute('data-open'), 10));
      });

      var atc = this.querySelector('[data-scroll-atc]');
      if (atc) atc.addEventListener('click', () => this.scrollToBuy());

      // Pause rules for autoplay
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.addEventListener('focusin', () => { this.hovered = true; });
      this.addEventListener('focusout', () => { this.hovered = false; });
      this.track.addEventListener('pointerdown', () => { this.paused = true; }, { passive: true });
      this.track.addEventListener('touchstart', () => { this.paused = true; }, { passive: true });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
        }, { threshold: 0.25 });
        this.io.observe(this);
      } else {
        this.visible = true;
      }

      this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion.matches && this.slides.length > 1;
      this.speed = Math.max(2000, parseInt(this.dataset.speed, 10) || 4000);
      if (this.autoplay && !window.Shopify?.designMode) this.timer = setInterval(this.tick, this.speed);

      this.setupLightbox();
      this.onScroll();

      // Theme editor: jump to the block being edited
      this.onBlockSelect = (e) => {
        var slide = this.track.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (slide) { this.paused = true; this.scrollToSlide(this.slides.indexOf(slide)); }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.io) this.io.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    slideWidth() {
      var first = this.slides[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    maxScroll() { return this.track.scrollWidth - this.track.clientWidth; }

    step(dir, user) {
      if (user) this.paused = true;
      var max = this.maxScroll();
      var left = this.track.scrollLeft;
      if (dir > 0 && left >= max - 4) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      this.track.scrollBy({ left: dir * this.slideWidth(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    scrollToSlide(i) {
      var slide = this.slides[i];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
    }

    tick() {
      if (this.paused || this.hovered || !this.visible || document.hidden) return;
      if (this.dialog && this.dialog.open) return;
      this.step(1, false);
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        var max = this.maxScroll();
        var left = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = left <= 4;
        if (this.nextBtn) this.nextBtn.disabled = max <= 4;
        if (this.bar) {
          var visibleRatio = max > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
          var w = Math.max(visibleRatio, 0.12);
          var pct = max > 0 ? left / max : 0;
          this.bar.style.width = (w * 100) + '%';
          this.bar.style.transform = 'translateX(' + (pct * (1 / w - 1) * 100) + '%)';
        }
      });
    }

    /* ---------- Lightbox ---------- */
    setupLightbox() {
      // showModal() puts the dialog in the browser's top layer, so it is never clipped by
      // the section's overflow and it still inherits the section's CSS variables.
      if (!this.dialog) return;
      var q = (sel) => this.dialog.querySelector(sel);
      q('[data-close]').addEventListener('click', () => this.closeLightbox());
      q('[data-lb-prev]').addEventListener('click', () => this.renderLightbox(this.current - 1));
      q('[data-lb-next]').addEventListener('click', () => this.renderLightbox(this.current + 1));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.closeLightbox(); });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.renderLightbox(this.current + 1);
        if (e.key === 'ArrowLeft') this.renderLightbox(this.current - 1);
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        var opener = this.track.querySelector('[data-open="' + this.current + '"]');
        if (opener) opener.focus({ preventScroll: true });
      });

      // Swipe between reviews on touch when a review has a single photo
      var startX = null;
      this.stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.stage.addEventListener('touchend', (e) => {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var media = this.stage.querySelector('[data-lb-media]');
        var multi = media && media.children.length > 1;
        if (!multi && Math.abs(dx) > 50) this.renderLightbox(this.current + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    renderLightbox(i) {
      var n = this.slides.length;
      this.current = (i + n) % n;
      var tpl = this.slides[this.current].querySelector('template[data-full]');
      if (!tpl) return;
      this.stage.replaceChildren(tpl.content.cloneNode(true));
      this.stage.scrollTop = 0;
      if (this.pos) this.pos.textContent = (this.current + 1) + ' / ' + n;
      this.buildPhotoDots();
    }

    // Dots for reviews that have more than one photo
    buildPhotoDots() {
      var media = this.stage.querySelector('[data-lb-media]');
      if (!media || media.children.length < 2) return;
      var frames = Array.prototype.slice.call(media.children);
      var wrap = document.createElement('div');
      wrap.className = 'cpr-lb__dots';
      var dots = frames.map(function (frame, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cpr-lb__dot';
        dot.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + frames.length);
        dot.addEventListener('click', function () {
          media.scrollTo({ left: frame.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
        wrap.appendChild(dot);
        return dot;
      });
      var mark = function () {
        var i = Math.round(media.scrollLeft / (media.clientWidth || 1));
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      media.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      var holder = document.createElement('div');
      holder.className = 'cpr-lb__media-wrap';
      media.parentNode.insertBefore(holder, media);
      holder.appendChild(media);
      holder.appendChild(wrap);
      mark();
    }

    openLightbox(i) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.paused = true;
      this.renderLightbox(i);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    closeLightbox() { if (this.dialog && this.dialog.open) this.dialog.close(); }

    scrollToBuy() {
      var target = document.querySelector('product-form, form[action*="/cart/add"]');
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  }

  customElements.define('photo-reviews-carousel', PhotoReviewsCarousel);
})();
